import { useAuth } from "@clerk/clerk-react";
import { useState } from "react";
// import { setAuthToken } from "../store/session/slice";

export const useGetToken = () => {
  const { getToken } = useAuth();
  return getToken;
};

export const useAuthToken = () => {
  const [token, setToken] = useState<string | null>(null);
  // const { getToken } = useAuth();

  // const fetchToken = async () => {
  //   const token = await getToken();

  //   return token;
  // };

  // useEffect(() => {
  //   // const token = localStorage.getItem("authToken") || "123123";
  //   // dispatch(setAuthToken("123123"));
  //   const token = fetchToken();
  //   setToken(token || null);
  // }, []);

  return { token, setToken };
};
